var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMySubscriptionsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H21C21.7956 5 22.5587 5.28973 23.1213 5.80546C23.6839 6.32118 24 7.02065 24 7.75V27L16.5 22.875L9 27V7.75C9 7.02065 9.31607 6.32118 9.87868 5.80546C10.4413 5.28973 11.2044 5 12 5Z",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMySubscriptionsWhite);
export default __webpack_public_path__ + "static/media/Icon_MySubscriptions_White.955fd96d8b194e34e0e3e322fee0ddef.svg";
export { ForwardRef as ReactComponent };